import { Box, Typography } from "@mui/material";
import QuotesTab from "../Tabs/quotesTab";

/**
 * Component representing a section for displaying recent quotes.
 *
 * @returns {JSX.Element} - React JSX element representing the recent quotes table
 */
const RecentQuotes = () => {
	return (
		<>
			<Box pt="1.5em">
				<Typography variant="pageHeader">Recent quotes</Typography>
			</Box>
			<QuotesTab />
		</>
	);
};

export default RecentQuotes;
